/**
 * Infinite Scroll for Shopify Collection Grids
 *
 * Automatically loads the next page of products when scrolling near
 * the pagination area. Works with facets.js — resets on filter changes.
 */
(function () {
  const LOAD_THRESHOLD = 600; // px before pagination to trigger load

  let loading = false;
  let observer = null;
  let scrollFallbackBound = false;

  function getProductGrid() {
    return document.getElementById('product-grid');
  }

  function getPaginationWrapper() {
    return document.querySelector('.pagination-wrapper');
  }

  function getSentinel() {
    return document.getElementById('infinite-scroll-sentinel');
  }

  function ensureSentinel() {
    const pagination = getPaginationWrapper();
    if (!pagination) return null;

    let sentinel = getSentinel();
    if (!sentinel) {
      sentinel = document.createElement('div');
      sentinel.id = 'infinite-scroll-sentinel';
      sentinel.style.cssText = 'height:1px;width:100%;';
      pagination.parentNode.insertBefore(sentinel, pagination.nextSibling);
    }

    return sentinel;
  }

  function getNextPageUrl() {
    const pagination = getPaginationWrapper();
    if (!pagination) return null;

    // Shopify uses "pagination__item--prev" for the visual right-arrow (next page).
    const nextLink =
      pagination.querySelector('.pagination__item--prev.pagination__item-arrow[href]') ||
      pagination.querySelector('.pagination__list li:last-child .pagination__item-arrow[href]');

    if (!nextLink) return null;
    const href = nextLink.getAttribute('href');
    if (!href) return null;
    // Strip any anchor (#products etc.) for clean fetch
    return href.split('#')[0];
  }

  function hidePagination() {
    const pagination = getPaginationWrapper();
    if (!pagination) return;

    // Keep pagination in DOM for link parsing, but remove visual clutter.
    pagination.style.visibility = 'hidden';
    pagination.style.height = '0';
    pagination.style.overflow = 'hidden';
    pagination.style.margin = '0';
    pagination.style.padding = '0';
    pagination.setAttribute('aria-hidden', 'true');
  }

  function showLoadingIndicator() {
    let indicator = document.getElementById('infinite-scroll-loading');
    if (!indicator) {
      indicator = document.createElement('div');
      indicator.id = 'infinite-scroll-loading';
      indicator.style.cssText =
        'text-align:center;padding:2rem;color:rgba(250,250,250,0.5);font-size:1.3rem;';
      indicator.textContent = 'Laden...';
      const pagination = getPaginationWrapper();
      if (pagination) {
        pagination.parentNode.insertBefore(indicator, pagination);
      }
    }
    indicator.style.display = 'block';
  }

  function hideLoadingIndicator() {
    const indicator = document.getElementById('infinite-scroll-loading');
    if (indicator) indicator.style.display = 'none';
  }

  function loadNextPage() {
    if (loading) return;
    const nextUrl = getNextPageUrl();
    if (!nextUrl) return;

    loading = true;
    showLoadingIndicator();

    // Fetch the next page as a section render
    const url = new URL(nextUrl, window.location.origin);

    fetch(url.toString())
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Grab new product items
        const newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          const items = newGrid.querySelectorAll('.grid__item');
          const currentGrid = getProductGrid();
          if (currentGrid && items.length > 0) {
            items.forEach(function (item) {
              currentGrid.appendChild(item);
            });
          }
        }

        // Update pagination with the new page's pagination (for next-next page link)
        const newPagination = doc.querySelector('.pagination-wrapper');
        const currentPagination = getPaginationWrapper();
        if (currentPagination && newPagination) {
          currentPagination.innerHTML = newPagination.innerHTML;
          currentPagination.setAttribute(
            'data-page',
            newPagination.getAttribute('data-page') || ''
          );
        } else if (currentPagination && !newPagination) {
          // No more pages — remove pagination entirely
          currentPagination.remove();
          const sentinel = getSentinel();
          if (sentinel) sentinel.remove();
        }

        // Keep pagination hidden (infinite scroll replaces it)
        hidePagination();
        hideLoadingIndicator();
        loading = false;

        // Keep client-side quick text filter active for newly appended items.
        if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.applyCollectionTextFilter === 'function') {
          FacetFiltersForm.applyCollectionTextFilter();
        }

        // Re-check if we need to load more (viewport might still be near bottom)
        checkAndLoad();
      })
      .catch(function () {
        hideLoadingIndicator();
        loading = false;
        // On error, show pagination as fallback
        var pagination = getPaginationWrapper();
        if (pagination) pagination.style.display = '';
      });
  }

  function checkAndLoad() {
    var sentinel = getSentinel();
    if (!sentinel || !getNextPageUrl()) return;

    var rect = sentinel.getBoundingClientRect();
    if (rect.top < window.innerHeight + LOAD_THRESHOLD) {
      loadNextPage();
    }
  }

  function init() {
    var pagination = getPaginationWrapper();
    if (!pagination) return;
    if (!getNextPageUrl()) return;
    var sentinel = ensureSentinel();
    if (!sentinel) return;

    // Hide pagination numbers, use infinite scroll instead
    hidePagination();

    // Use IntersectionObserver when available
    if ('IntersectionObserver' in window) {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadNextPage();
            }
          });
        },
        { rootMargin: LOAD_THRESHOLD + 'px' }
      );
      observer.observe(sentinel);
    }

    // Always keep a scroll/resize fallback in place for browser/layout edge cases.
    if (!scrollFallbackBound) {
      window.addEventListener('scroll', checkAndLoad, { passive: true });
      window.addEventListener('resize', checkAndLoad, { passive: true });
      scrollFallbackBound = true;
    }

    // Try immediately in case viewport is already near the sentinel.
    setTimeout(checkAndLoad, 60);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize after facets.js re-renders the grid (MutationObserver on ProductGridContainer)
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    var mutationObserver = new MutationObserver(function () {
      // Small delay to let facets.js finish DOM updates
      loading = false;
      if (observer) observer.disconnect();
      setTimeout(init, 100);
    });
    mutationObserver.observe(gridContainer, { childList: true });
  }
})();
